import React, { useEffect, useMemo, useState } from 'react';

import { Backdrop, NotificationText, Typography } from '@room-match/shared-ui-components';
import { Grid } from '@material-ui/core';
import { FlexContainer, MainCont, SaveButton, SelectionButton, SelectionContainer } from './BillingInformation.styles';
import Business from './Business/Business';
import Individual from './Individual/Individual';
import { useBillingInformationForm } from './BillingInformationForm';
import { accountService } from 'shared/services/accountService';
import { useQueryClient } from 'react-query';
import { IAccountUpdatePayload } from 'shared/interfaces/IAccount';
import { INITIAL_BILLING_INFORMATION } from 'shared/constants/INITIAL_BILLING_INFORMATION';

const { getAccount, updateAccount } = accountService();
const ContactInformation = () => {
  const { data: accountDetails, isLoading: getAccountIsLoading } = getAccount();
  const { mutateAsync, isLoading: updateAccountIsLoading } = updateAccount();
  const [showSuccess, handleShowSuccess] = useState<boolean>(false);

  const queryClient = useQueryClient();

  const getAccountDetails = useMemo(() => {
    return accountDetails ? accountDetails.data : undefined;
  }, [accountDetails]);

  const handleSubmit = async (values: IAccountUpdatePayload) => {
    mutateAsync(values, {
      onSuccess: () => {
        queryClient.invalidateQueries(['accounts'], {
          refetchInactive: true,
        });
        handleShowSuccess(true);
      },
    });
  };

  const { form } = useBillingInformationForm({
    onSubmit: handleSubmit,
    data: getAccountDetails,
  });

  useEffect(() => {
    if (!form.values.billing_information) {
      form.setFieldValue('billing_information', INITIAL_BILLING_INFORMATION);
      form.setFieldValue('billing_information.business_representative.first_name', form.values.first_name);
      form.setFieldValue('billing_information.business_representative.last_name', form.values.last_name);
      form.setFieldValue(
        'billing_information.business_representative.phone_country_code',
        form.values.country_code?.toLowerCase() || 'us',
      );
      form.setFieldValue('billing_information.business_representative.country', form.values.country_code || 'US');
      form.setFieldValue(
        'billing_information.business_information.phone_country_code',
        form.values.country_code?.toLowerCase() || 'us',
      );
      form.setFieldValue('billing_information.business_information.country', form.values.country_code || 'US');
      form.setFieldValue(
        'billing_information.personal_information.phone_country_code',
        form.values.country_code?.toLowerCase() || 'us',
      );
      form.setFieldValue('billing_information.personal_information.country', form.values.country_code || 'US');
    }
  }, [form.values.billing_information]);

  console.log(form.values);

  return (
    <>
      <MainCont>
        <Grid item>
          <p style={{ fontSize: 25 }}>How You Will Be Paid</p>
        </Grid>
        <Grid item>
          <SelectionContainer>
            <SelectionButton
              isActive={form.values.billing_information?.personal_information?.primary}
              onClick={() => {
                form.setFieldValue('billing_information.personal_information.primary', true);
                form.setFieldValue('billing_information.business_information.primary', false);
                form.handleSubmit();
              }}
            >
              I am an Individual
            </SelectionButton>
            <SelectionButton
              isActive={form.values.billing_information?.business_information?.primary}
              onClick={() => {
                form.setFieldValue('billing_information.business_information.primary', true);
                form.setFieldValue('billing_information.personal_information.primary', false);
                form.handleSubmit();
              }}
            >
              I am a Business
            </SelectionButton>
          </SelectionContainer>
        </Grid>
        {form.values.billing_information && (
          <>
            {form.values.billing_information.personal_information?.primary === true ? (
              <Individual form={form} />
            ) : (
              <Business form={form} />
            )}
          </>
        )}

        <Grid item>
          <FlexContainer item>
            <SaveButton
              color="primary"
              variant="contained"
              disableElevation
              onClick={() => form.handleSubmit()}
              disabled={!form.dirty}
              // disabled={true}
            >
              Save Changes
            </SaveButton>
            <NotificationText show={showSuccess} setShow={handleShowSuccess} />
          </FlexContainer>
        </Grid>
      </MainCont>
      <Backdrop
        isLoading={getAccountIsLoading ? getAccountIsLoading : updateAccountIsLoading ? updateAccountIsLoading : false}
      />
    </>
  );
};

export default ContactInformation;
